/** The row above the calendar months: previous / next arrows and each month's name. */
import { ChevronLeft, ChevronRight } from 'lucide-react';

import { MONTH_NAMES } from './date-keys';

export interface MonthNavProps {
  /** Months counted from year 0 (`year * 12 + month`). */
  shown: number[];
  onStep: (by: 1 | -1) => void;
}

const arrowStyle = {
  width: 28,
  height: 28,
  borderRadius: 7,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'var(--nb-muted)',
} as const;

export function MonthNav({ shown, onStep }: MonthNavProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
      <button
        type="button"
        aria-label="Previous month"
        onClick={() => onStep(-1)}
        style={arrowStyle}
      >
        <ChevronLeft size={15} aria-hidden />
      </button>
      <div aria-live="polite" className="dtr-month-names">
        {shown.map((m) => (
          <div
            key={m}
            className="dtr-month-name"
            style={{
              flex: 1,
              textAlign: 'center',
              fontSize: 13.5,
              fontWeight: 800,
              color: 'var(--nb-ink)',
            }}
          >
            {MONTH_NAMES[m % 12]}{' '}
            <span style={{ fontWeight: 500, color: 'var(--nb-subtle)' }}>{Math.floor(m / 12)}</span>
          </div>
        ))}
      </div>
      <button type="button" aria-label="Next month" onClick={() => onStep(1)} style={arrowStyle}>
        <ChevronRight size={15} aria-hidden />
      </button>
    </div>
  );
}
